var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgTransactions = function SvgTransactions(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.467 8.865a.667.667 0 0 0-.943 0l-1.526 1.526V4c0-.367-.3-.667-.667-.667-.367 0-.666.3-.666.667v6.391L9.136 8.865a.668.668 0 0 0-.943 0 .668.668 0 0 0 0 .942l2.666 2.665c.039.04.088.061.133.089.028.016.05.04.082.054.027.012.058.012.086.018.142.038.29.038.427-.018.03-.013.051-.036.079-.053.046-.027.095-.05.136-.09l2.664-2.665a.668.668 0 0 0 0-.942M7.8 7.128a.667.667 0 0 1-.942 0L5.33 5.602v6.39c0 .368-.3.668-.666.668a.668.668 0 0 1-.667-.667V5.602L2.47 7.128a.668.668 0 0 1-.943 0 .668.668 0 0 1 0-.942L4.193 3.52c.039-.04.088-.061.134-.089.028-.016.05-.04.08-.054.028-.012.059-.012.088-.018a.663.663 0 0 1 .426.018c.03.013.052.036.079.053.047.027.095.05.136.09L7.8 6.186c.259.259.259.683 0 .942",
    fill: "currentColor"
  })));
};

export default SvgTransactions;